import {
  FETCH_ASSIGNMENTS_REQUEST,
  FETCH_ASSIGNMENTS_SUCCESS,
  FETCH_ASSIGNMENTS_FAILURE,
  FETCH_ASSIGNMENT_DETAILS_REQUEST,
  FETCH_ASSIGNMENT_DETAILS_SUCCESS,
  FETCH_ASSIGNMENT_DETAILS_FAILURE,
  DELETE_ASSIGNMENT_REQUEST,
  DELETE_ASSIGNMENT_SUCCESS,
  DELETE_ASSIGNMENT_FAILURE,
} from "./actionTypes";

const initialState = {
  loading: false,
  assignments: { data: [], total: 0 },
  selectedAssignment: null,
  submissions: [],
  error: null,
};

const assignmentReducer = (state = initialState, action) => {
  switch (action.type) {
    // =============================
    // FETCH ALL ASSIGNMENTS
    // =============================
    case FETCH_ASSIGNMENTS_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_ASSIGNMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        assignments: {
          data: action.payload?.data || [],
          total:
            action.payload?.total > 0
              ? action.payload.total
              : (action.payload?.data?.length || 0),
        },
      };

    case FETCH_ASSIGNMENTS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // =============================
    // FETCH SINGLE ASSIGNMENT DETAILS
    // =============================
    case FETCH_ASSIGNMENT_DETAILS_REQUEST:
      return { ...state, loading: true, selectedAssignment: null, submissions: [] };

    case FETCH_ASSIGNMENT_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        selectedAssignment: action.payload.assignment,
        submissions: action.payload.submissions || [],
         total: action.payload.total || 0,
      };

    case FETCH_ASSIGNMENT_DETAILS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // =============================
    // DELETE ASSIGNMENT
    // =============================
    case DELETE_ASSIGNMENT_REQUEST:
      return { ...state, loading: true };

    case DELETE_ASSIGNMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        assignments: {
          ...state.assignments,
          data: (state.assignments?.data || []).filter(
            (item) => item?._id !== action.payload?.data?._id
          ),
        },
      };

    case DELETE_ASSIGNMENT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default assignmentReducer;
